import React from 'react';
import { legalCharter } from '../config/legalCharter';

export default function LegalCharterModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(15,23,42,0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 3000,
      }}
    >
      <div
        style={{
          backgroundColor: 'var(--bg-card)',
          border: '2px solid var(--accent-shout)',
          padding: '30px',
          borderRadius: '12px',
          maxWidth: '600px',
          width: '100%',
          maxHeight: '80vh',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3
            style={{
              margin: 0,
              fontSize: '18px',
              fontWeight: '900',
              color: 'var(--text-primary)',
            }}
          >
            ⚖️ Legal Charter
          </h3>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: '#94a3b8',
              fontSize: '24px',
              cursor: 'pointer',
              padding: '0',
              lineHeight: '1',
            }}
          >
            ×
          </button>
        </div>

        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            paddingRight: '10px',
            marginBottom: '20px',
          }}
        >
          {legalCharter.fullCharterSections.map((section, index) => (
            <div key={index} style={{ marginBottom: '20px' }}>
              <h4
                style={{
                  margin: '0 0 10px 0',
                  fontSize: '14px',
                  fontWeight: '800',
                  color: '#f59e0b',
                  textTransform: 'uppercase',
                }}
              >
                {section.title}
              </h4>
              <p
                style={{
                  margin: 0,
                  fontSize: '13px',
                  color: '#94a3b8',
                  lineHeight: '1.6',
                }}
              >
                {section.body}
              </p>
            </div>
          ))}
        </div>

        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '12px 0',
            backgroundColor: '#ea580c',
            color: 'var(--text-primary)',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '800',
            textTransform: 'uppercase',
            cursor: 'pointer',
            boxSizing: 'border-box',
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
}
